const LayoutStyle = {
    NEWSPAPER: 0,
    GRID: 1,
    ROWS: 2
};

var actualPage = 1;
var actualCategory = -1;
var firstData = true;

async function fetchData(url) {
    try {
        const response = await fetch(url, {
			method: 'GET',
			credentials: 'include',  // This sends authentication cookies
			headers: {
				'Content-Type': 'application/json'
			}
		});
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return await response.json(); // Return parsed JSON
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error; // Re-throw error to handle it outside
    }
}
	
window.onload = function(){
	const exePostFilters = Array.from(document.getElementsByClassName("wp-block-exe-post-filter-block"));
	exePostFilters.forEach(exePostFilter => {
		const exePostsHolder = exePostFilter.getElementsByClassName("exe-post-filter-posts-holder")[0];
		const baseCategory = exePostFilter.dataset.baseCategory;
		const paging = exePostFilter.dataset.paging;
		const itemsPerPage = exePostFilter.dataset.perPage;
		const exeButtonsHolder = exePostFilter.getElementsByClassName("exe-post-filter-buttons-holder")[0];
		const allButton = exeButtonsHolder.getElementsByClassName("exe-post-filter-button")[0];
		
		const postsStyle = Number(exePostsHolder.dataset.style)
		switch(postsStyle){
			case LayoutStyle.NEWSPAPER:
				exePostsHolder.classList.add("exe-post-filter-newspaper");
				break;
			case LayoutStyle.GRID:
				exePostsHolder.classList.add("exe-post-filter-grid");
				break;
			case LayoutStyle.ROWS:
				exePostsHolder.classList.add("exe-post-filter-rows");
				break;
		}
		
		if(allButton && !allButton.dataset.category){ // it is all button when it does not have any category associated with it
			allButton.addEventListener("click", (event) => onCategoryButtonClick(event, exePostFilter));
			allButton.firstChild.click(); // if all button is present, load all posts immediately
		}
		
		// list l1 categories from base category
		fetchData(`/wp-json/wp/v2/categories?parent=${baseCategory}&_fields=id,name,slug&hide_empty=true`)
		.then(data => {
			createCategoryButtons(exePostFilter, data);
		})
		.catch(error => console.error("Fetch failed:", error));
		
		// do paging if enabled
	});
};

function setHolderButtonsEnabled(holder, state){
	const buttons = Array.from(holder.childNodes);
	buttons.forEach(button => {
		if(state){
			button.classList.remove("exe-disabled-link");
		}else{
			button.classList.add("exe-disabled-link");
		}
	});
}

function createCategoryButtons(exePostFilter, childCategories){
	// create buttons based on base categories
	const buttonsHolder = exePostFilter.getElementsByClassName("exe-post-filter-buttons-holder")[0];
	if(childCategories){
		childCategories.forEach((category) => {
			// create the button
			const outer = document.createElement("div");
			outer.classList.add("exe-post-filter-button", "wp-block-button", "exe-button", "exe-bluewhite-button", "exe-sector");
			const inner = document.createElement("span");
			inner.classList.add("wp-block-button__link", "wp-element-button");
			inner.innerText = category.name;
			inner.dataset.id = category.id;
			inner.dataset.slug = category.slug;
			outer.appendChild(inner);
			
			// add event listener to them based on their category
			outer.addEventListener("click", (event) => onCategoryButtonClick(event, exePostFilter));
			
			// append the button
			buttonsHolder.appendChild(outer);
		});
	}
}

function onCategoryButtonClick(event, exePostFilter){
	const buttonsHolder = exePostFilter.getElementsByClassName("exe-post-filter-buttons-holder")[0];
	const pagesHolder = exePostFilter.getElementsByClassName("exe-post-filter-pages-holder")[0];
	const triggerButton = event.target;
	const category = triggerButton.dataset.id;
	
	pagesHolder.innerHTML = "";
	
	const buttons = Array.from(buttonsHolder.children);
	buttons.forEach(button => {
		button.firstChild.classList.remove("exe-button-selected");
	});
	triggerButton.classList.add("exe-button-selected");
	setHolderButtonsEnabled(buttonsHolder, false);
	
	actualPage = 1;
	
	loadPostsWithAnimation(exePostFilter, category ? category : -1);
}

function getAutoHeight(element) {
    // Temporarily make the element visible to measure its natural height
    element.style.height = "auto";
    const height = element.scrollHeight; 
	element.style.height = "0px";
    return height;
}

async function loadPostsWithAnimation(exePostFilter, categoryId){
	const postsHolder = exePostFilter.getElementsByClassName("exe-post-filter-posts-holder")[0];
	if(!firstData){
		await playAnimationBeforeLoadingPosts(postsHolder);
	}else{	
		firstData = false;
	}
	console.log("animation ended");
	loadPosts(exePostFilter, categoryId);
}

function playAnimationBeforeLoadingPosts(postsHolder) {
    return new Promise((resolve) => {
        const height = getAutoHeight(postsHolder);
        postsHolder.style.height = `${height}px`;

        setTimeout(() => {
            postsHolder.style.height = "0";
            setTimeout(() => {
				resolve();
			}, 125);
        }, 10);
    });
}

function playAnimatonAfterLoadingPosts(postsHolder){
	return new Promise((resolve) => {
        const height = getAutoHeight(postsHolder);

        setTimeout(() => {
            postsHolder.style.height = `${height}px`; // Animate height
            setTimeout(() => {
				postsHolder.style.height = "auto";
				resolve();
			}, 125);
        }, 10);
    });
}

function loadPosts(exePostFilter, categoryId){
	const paging = exePostFilter.dataset.paging;
	const perPage = exePostFilter.dataset.perPage;
	
	if(categoryId == -1){
		categoryId = exePostFilter.dataset.baseCategory
	}
	actualCategory = categoryId;
	
	const postsHolder = exePostFilter.getElementsByClassName("exe-post-filter-posts-holder")[0];
	const buttonsHolder = exePostFilter.getElementsByClassName("exe-post-filter-buttons-holder")[0];
	
	const postsStyle = Number(postsHolder.dataset.style)

	
	const url = `/wp-json/post-filter/v1/posts/${categoryId}?per_page=${perPage}&page=${actualPage}`;
	fetchData(url)
	.then(data => {
		postsHolder.innerHTML = "";
		data.posts.forEach(item => {
			let categories = '';
			item.categories.forEach(category => {
				categories += `<span>${category}</span> : `;
			});
			categories = categories.slice(0, -3);
			var date = "";
			var categoriesDiv = "";
			if(postsStyle == LayoutStyle.NEWSPAPER){
				date = `
					<div class="exe-post-filter-post-item-date">
						${item.date}
					</div>
				`;
			}
			if(postsStyle != LayoutStyle.ROWS){
				categoriesDiv = `
					<div class="exe-post-filter-post-item-categories">
						${categories}
					</div>
				`;
			}

			postsHolder.innerHTML += `
				<div class="exe-post-filter-post-item">
					<div class="exe-post-filter-post-item-image">
						<a href="${item.permalink}">
							<img src="${item.imagelink}" alt="${item.title}">
						</a>
					</div>
					<div class="exe-post-filter-post-item-content">
						<h2 class="exe-post-filter-post-item-title">
							<a href="${item.permalink}">${item.title}</a>
						</h2>
						${categoriesDiv}
						${date}
						<div class="exe-post-filter-post-item-excerpt exe-text">
							${item.excerpt}
						</div>
					</div>
				</div>
			`;
		});
		
		playAnimatonAfterLoadingPosts(postsHolder)
		setHolderButtonsEnabled(buttonsHolder, true);
			
		if(paging && data.post_count > perPage){
			createPaging(exePostFilter, data.post_count);
		}
	})
	.catch(error => console.error("Fetch failed:", error));
}

function createPaging(exePostFilter, postCount){
	const perPage = exePostFilter.dataset.perPage;
	const pageCount = Math.ceil(postCount / perPage);
	const exePagesHolder = exePostFilter.getElementsByClassName("exe-post-filter-pages-holder")[0];
	exePagesHolder.innerHTML = "";
	
	for(var i=1; i<=pageCount; i++){
		// create the button
		const outer = document.createElement("div");
		outer.classList.add("exe-post-filter-button", "wp-block-button", "exe-button", "exe-bluewhite-button", "exe-sector");
		const inner = document.createElement("span");
		inner.classList.add("wp-block-button__link", "wp-element-button", "wp-small-button");
		inner.innerText = i;
		inner.dataset.page = i;
		if(actualPage == i){
			inner.classList.add("exe-button-selected");
		}
		outer.appendChild(inner);
		
		// add event listener
		outer.addEventListener("click", (event) => onPageButtonClick(event, exePostFilter));
		
		// append button
		exePagesHolder.appendChild(outer);
	}
}

function onPageButtonClick(event, exePostFilter){
	const clickedButton = event.target;
	const exePagesHolder = exePostFilter.getElementsByClassName("exe-post-filter-pages-holder")[0];
	const exePageButtons = Array.from(exePagesHolder.childNodes);
	exePageButtons.forEach(exePageButton => {
		exePageButton.classList.remove("exe-button-selected");
	});
	
	clickedButton.classList.add("exe-button-selected");
	setHolderButtonsEnabled(exePagesHolder, false);
	
	actualPage = clickedButton.dataset.page;
	loadPosts(exePostFilter, actualCategory)
}

/*
const [categories, setCategories] = useState([]);
	const [posts, setPosts] = useState([]);
	
	const fetchData = async (url, setStateFunction) => {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Failed to fetch data from ${url}');
            const data = await response.json();
            setStateFunction(data);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    useEffect(() => {
        (async () => {
			await fetchData('/wp-json/wp/v2/categories?parent=${attributes.baseCategory}&_fields=id,name,slug', setCategories);
		})();
		
		// if all button present, otherwise do not load anything
		if(attributes.showAllButton){
			(async () => {
				await fetchData('/wp-json/post-filter/v1/posts/${attributes.baseCategory}?per_page=${attributes.itemsPerPage}&page=1', setPosts);
			})();
		}
    }, []);


{categories.map((category) => (
					<button key={category.id} data-id={category.id} name={category.slug}>
						{category.name}
					</button>
				))}
				*/